import React, { useEffect } from 'react'
import CustomTitle from '../../components/UI/title/CustomTitle'
import PageContent from '../../components/PageContent/PageContent'
import './style.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { setButtonClick, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice'
import { setIsShowButtonNot } from '../../store/buttonNotSlice'
import ReplaceContent from './ReplaceContent'
import useMixpanel from '../../hooks/useMixpanel'

export default function Replace() {



    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Continue'));
        dispatch(setIconButton(''));
        dispatch(setIsShowButtonNot(false));
    }, []);

    const { trackP1Event } = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            dispatch(setButtonClick(false));
            trackP1Event('onboarding_replace', {})
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch]);

    return (
        <div className="replace page">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '24rem' }}
                        title={'AI copilot will replace multiple employees and help implement your plan'}
                    />
                    <ReplaceContent />

                </div>
            </PageContent>
        </div>
    )
}
